import React from 'react';
import ReviewsContainerV2 from './ReviewsContainerV2/ReviewsContainerV2';
import { jsx as _jsx } from "react/jsx-runtime";
const ReviewsTabV2 = _ref => {
  let {
    hosting,
    appKey,
    mpacBaseUrl,
    user,
    vendorName,
    vendorLogo,
    onSeeMoreReviewsClick,
    loginHref,
    appRating,
    cloudCompatibleProducts,
    appDeploymentType,
    productHostingOptions,
    isServerAppEos
  } = _ref;
  return /*#__PURE__*/_jsx(ReviewsContainerV2, {
    hosting: hosting,
    appKey: appKey,
    user: user,
    mpacBaseUrl: mpacBaseUrl,
    loginHref: loginHref,
    vendorName: vendorName,
    vendorLogo: vendorLogo,
    appRating: appRating,
    onSeeMoreReviewsClick: onSeeMoreReviewsClick,
    cloudCompatibleProducts: cloudCompatibleProducts,
    appDeploymentType: appDeploymentType,
    productHostingOptions: productHostingOptions,
    isServerAppEos: isServerAppEos
  });
};
const ReviewsTabV2Memoized = /*#__PURE__*/React.memo(ReviewsTabV2);
export default ReviewsTabV2Memoized;